/**
 * Functions
 * Product Selector Quote Form
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'functions';
const log = debug(MODULE_NAME);


//
// Dependencies
import { MODULE_WORD_SELECTOR } from './config';

/**
 * Extracts values from the `<select>` input in a Word Selector Component
 * @param wordSelector
 * @returns {Array}
 */
export function extractWordSelectorInputValues (wordSelector) {
	let $wordSelector = $(wordSelector),
		selectInput = $wordSelector.find('select')[0],
		values = [];

	Array.from(selectInput.options).forEach((option) => {
		let $option = $(option);

		values.push({
			value: option.value,
			label: option.label,
			icon: $option.data('icon'),
			selected: option.selected,
		});
	});

	return values;
}

/**
 * Extracts all values from word selector components.
 * @param wordSelectors
 * @returns {Object}
 */
export function extractAllWordSelectorValues (wordSelectors) {
	let values = {};

	$(wordSelectors).each(function () {
		let $wordSelector = $(this),
			name = $wordSelector.data(MODULE_WORD_SELECTOR);
		values[name] = extractWordSelectorInputValues(this);
	});

	return values;
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ps-quote-form/functions.js